// src/pages/admin/billing/AdminBillingPaymentsPage.js
import React from 'react';
import AdminLayout from '../../../components/admin/AdminLayout';

function AdminBillingPaymentsPage() {
  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Paiements</h1>
      <p>Suivi et enregistrement des paiements (à connecter à PocketBase).</p>
    </AdminLayout>
  );
}

export default AdminBillingPaymentsPage;
